export default "__VITE_ASSET__bdacfc55__"